module.exports = __webpack_public_path__ + "static/img/Artboard.12b0fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Artboard.png
// module id = 2vyL
// module chunks = 1